import {
  NO_MENU_TEMPLATES_TEXT,
  NO_MENU_TEMPLATES_TITLE_TEXT,
  SELECT_RESTAURANT_TEXT,
} from '../constants';
import { MenuEmptyState } from '../components/MenuEmptyState';

type MenuDetailsEmptyProps = {
  hasRestaurants: boolean;
  hasTemplates: boolean;
  isLoading: boolean;
};

export const MenuDetailsEmpty: React.FC<MenuDetailsEmptyProps> = ({
  hasRestaurants,
  hasTemplates,
  isLoading,
}) => {
  if ((hasRestaurants && hasTemplates) || isLoading) return null;

  if (!hasRestaurants) {
    return <MenuEmptyState title={SELECT_RESTAURANT_TEXT} />;
  }

  return (
    <MenuEmptyState title={NO_MENU_TEMPLATES_TITLE_TEXT} description={NO_MENU_TEMPLATES_TEXT} />
  );
};
